import { status } from '../../config.ts'
import {
  articleCuotesPage1,
  articleDetail,
  articlesPage1,
  articleTypesPage1,
  categoriesPage1,
  creditAppleByRegisterNumber,
  creditAppleScenariosByRegisterNumber,
  creditAppleWithPromotionByRegisterNumber,
  creditByBodySerial,
  creditByRegisterNumber,
  creditByRegisterNumberOthers,
  creditLaptopWithPromotionByRegisterNumber,
  creditPhoneWithoutPromotionByRegisterNumber,
  creditPhoneWithPromotionByRegisterNumber,
  creditPreassignedDetail,
  creditUnpay,
  devicesInfo,
  enrolledHours,
  enrolledMoreThan30DaysBySerial,
  equalityDevicesInfo,
  insuranceRentabilityPage1,
  miscellaneousCredit,
  miscellaneousRentability,
  modelsNuovo,
  mundoDevicesInfo,
  otpVerify,
  QRImageData,
  readOriginCertificate,
  rentabilitiesActive,
  rentabilitiesActiveMoto,
  rentabilitiesPage1,
  rentabilitiesPage1Moto,
  segurosMercantil,
  supplier,
  supplierApple,
  supplierAutomotive,
  supplierMundo,
  supplierNuovoLaptop
} from './data.ts'
import {
  refinanceScenarioQuotesResponse,
  refinanceScenarios
} from '@/__mocks__/modules/articles/refinanceScenarios.ts'
import { wait } from '@/__mocks__/util/async.ts'
import { clientsPage1 } from '@/__mocks__/modules/clients/data.ts'

export default [
  {
    method: 'GET',
    path: '/credits?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, clientsPage1]
    }
  },
  {
    method: 'GET',
    path: '/credits/1/details',
    reply: async () => {
      await wait()
      return [status.ok, articleDetail]
    }
  },
  {
    method: 'POST',
    path: '/credits',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'DELETE',
    path: '/credits/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PATCH',
    path: '/credits/2',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PATCH',
    path: '/credits/2/status',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/credits/assigned/2',
    reply: async () => {
      await wait()
      return [status.ok, articlesPage1]
    }
  },
  {
    method: 'GET',
    path: '/product-types/active',
    reply: async () => {
      await wait()
      return [status.ok, articleTypesPage1]
    }
  },
  {
    method: 'GET',
    path: '/categories/catalog',
    reply: async () => {
      await wait()
      return [status.ok, categoriesPage1]
    }
  },
  {
    method: 'GET',
    path: '/categories/active',
    reply: async () => {
      await wait()
      return [status.ok, categoriesPage1]
    }
  },
  {
    method: 'GET',
    path: '/rentabilities/active',
    reply: async () => {
      await wait()
      return [status.ok, rentabilitiesActive]
    }
  },
  {
    method: 'GET',
    path: '/rentabilities/active?type=PRODUCT',
    reply: async () => {
      await wait()
      return [status.ok, rentabilitiesActive]
    }
  },
  {
    method: 'GET',
    path: '/rentabilities/active?type=MOTO',
    reply: async () => {
      await wait()
      return [status.ok, rentabilitiesActiveMoto]
    }
  },
  {
    method: 'GET',
    path: '/rentabilities?limit=50',
    reply: async () => {
      await wait()
      return [status.ok, rentabilitiesPage1]
    }
  },
  {
    method: 'GET',
    path: '/rentabilities?limit=50&type=PRODUCT',
    reply: async () => {
      await wait()
      return [status.ok, rentabilitiesPage1]
    }
  },
  {
    method: 'GET',
    path: '/rentabilities?limit=50&type=MOTO',
    reply: async () => {
      await wait()
      return [status.ok, rentabilitiesPage1Moto]
    }
  },
  {
    method: 'GET',
    path: '/insurance_rentability/active',
    reply: async () => {
      await wait()
      return [status.ok, insuranceRentabilityPage1]
    }
  },
  {
    method: 'GET',
    path: '/insurance_providers/catalog',
    reply: async () => {
      await wait()
      return [status.ok, segurosMercantil]
    }
  },
  {
    method: 'GET',
    path: '/credits/1/cuotes',
    reply: async () => {
      await wait()
      return [status.ok, articleCuotesPage1]
    }
  },
  {
    method: 'GET',
    path: '/refinancing/1/quotes',
    reply: async () => {
      await wait()
      return [
        status.ok,
        {
          message: 'OK',
          data: {
            refinancingAmount: 1,
            quotes: [
              {
                id: 1,
                name: 'Cuota 1 de 4',
                quote: '50.00',
                status: 'PAGADA',
                dueAt: '01/11/2025',
                paymentDate: '01/11/2025',
                paid: '50.00',
                type: 'PRODUCT'
              },
              {
                id: 2,
                name: 'Cuota 2 de 4',
                quote: '50.00',
                status: 'ATRASADA',
                dueAt: '01/01/2026',
                paymentDate: null,
                paid: '25.00',
                type: 'PRODUCT'
              },
              {
                id: 3,
                name: 'Cuota 3 de 4',
                quote: '50.00',
                status: 'ATRASADA',
                dueAt: '15/01/2026',
                paymentDate: null,
                paid: '0.00',
                type: 'PRODUCT'
              },
              {
                id: 4,
                name: 'Cuota 4 de 4',
                quote: '50.00',
                status: 'PENDIENTE',
                dueAt: '29/01/2026',
                paymentDate: null,
                paid: '0.00',
                type: 'PRODUCT'
              }
            ]
          }
        }
      ]
    }
  },
  {
    method: 'PUT',
    path: '/refinancing/1/quotes',
    reply: async () => {
      await wait()
      return [
        status.ok,
        { message: 'Crédito refinanciado con éxito.', data: null }
      ]
    }
  },
  ...refinanceScenarios.flatMap((scenario) => [
    {
      method: 'GET',
      path: `/refinancing/${scenario.creditId}/quotes`,
      reply: async () => {
        await wait()
        return [status.ok, refinanceScenarioQuotesResponse(scenario)]
      }
    },
    {
      method: 'PUT',
      path: `/refinancing/${scenario.creditId}/quotes`,
      reply: async () => {
        await wait()
        return [
          status.ok,
          { message: 'Crédito refinanciado con éxito.', data: null }
        ]
      }
    }
  ]),
  {
    method: 'DELETE',
    path: '/credits/1/cuotes/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/credits/2/pay-total-amount',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/credits/1/pay-cuote-amount',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/credits/assign-device-to-client',
    reply: async (config: { data?: string }) => {
      await wait()
      const { unpaidCredit } = JSON.parse(config.data ?? '{}')
      return [
        status.ok,
        { id: 1, unpayCredit: !!unpaidCredit, contractResponse: null }
      ]
    }
  },
  {
    method: 'POST',
    path: '/credit-preassigned',
    reply: async () => {
      await wait()
      return [status.ok, { data: { id: 87 } }]
    }
  },
  {
    method: 'GET',
    path: '/credit-preassigned/87/qr',
    reply: async () => {
      await wait()
      return [status.ok, 'mock-credit-preassigned-qr']
    }
  },
  {
    method: 'GET',
    path: '/credit-preassigned/87',
    reply: async () => {
      await wait()
      return [status.ok, creditPreassignedDetail]
    }
  },
  {
    method: 'POST',
    path: '/credit-miscellaneous',
    reply: async () => {
      await wait()
      return [status.ok, miscellaneousCredit]
    }
  },
  {
    method: 'GET',
    path: '/credit-miscellaneous/87/rentability',
    reply: async () => {
      await wait()
      return [status.ok, miscellaneousRentability]
    }
  },
  {
    method: 'POST',
    path: '/credits/assign-miscellaneous',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/credits/by-register-number/12345/2?supplierId=3&productTypeId=1',
    reply: async () => {
      await wait()
      return [status.ok, creditByRegisterNumber]
    }
  },
  {
    method: 'GET',
    path: '/credits/by-register-number/FAST01/2?supplierId=3&productTypeId=1',
    reply: async () => {
      await wait()
      return [status.ok, creditPhoneWithoutPromotionByRegisterNumber]
    }
  },
  {
    method: 'GET',
    path: '/mundo-grupo/devices/info/FAST01?clientId=2',
    reply: async () => {
      await wait()
      return [status.ok, mundoDevicesInfo]
    }
  },
  {
    method: 'GET',
    path: '/credits/by-register-number/PROMO01/2?supplierId=3&productTypeId=1',
    reply: async () => {
      await wait()
      return [status.ok, creditPhoneWithPromotionByRegisterNumber]
    }
  },
  {
    method: 'GET',
    path: '/credits/by-register-number/12345/2',
    reply: async () => {
      await wait()
      return [status.ok, creditByRegisterNumberOthers]
    }
  },
  {
    method: 'POST',
    path: '/credits/by-register-number/apple-product',
    reply: async (config: { data?: string }) => {
      await wait()
      const { registerNumber } = JSON.parse(config.data ?? '{}')
      return [
        status.ok,
        creditAppleScenariosByRegisterNumber[registerNumber] ??
          (registerNumber === 'PROMO01'
            ? creditAppleWithPromotionByRegisterNumber
            : creditAppleByRegisterNumber)
      ]
    }
  },
  {
    method: 'GET',
    path: '/credits/by-body-serial/automotive-product/12345/2?supplierId=3&productTypeId=6',
    reply: async () => {
      await wait()
      return [status.ok, creditByBodySerial]
    }
  },
  {
    method: 'POST',
    path: '/mosyle/devices/lookup',
    reply: async (config: { data?: string }) => {
      await wait()
      const { serialNumber } = JSON.parse(config.data ?? '{}')
      return [
        status.ok,
        {
          data: {
            isEnrolledMoreThan30Days:
              enrolledMoreThan30DaysBySerial[serialNumber] ?? false
          }
        }
      ]
    }
  },
  {
    method: 'GET',
    path: '/credits/enrolled-hours/12345',
    reply: async () => {
      await wait()
      return [status.ok, enrolledHours]
    }
  },
  {
    method: 'GET',
    path: '/devices/info/12345',
    reply: async () => {
      await wait()
      return [status.ok, devicesInfo]
    }
  },
  {
    method: 'GET',
    path: '/devices/info/LAPTOP01',
    reply: async () => {
      await wait()
      return [status.ok, devicesInfo]
    }
  },
  {
    method: 'GET',
    path: '/equality/devices/info/12345?clientId=2',
    reply: async () => {
      await wait()
      return [status.ok, equalityDevicesInfo]
    }
  },
  {
    method: 'GET',
    path: '/mundo-grupo/devices/info/12345?clientId=2',
    reply: async () => {
      await wait()
      return [status.ok, mundoDevicesInfo]
    }
  },
  {
    method: 'GET',
    path: '/equality/devices/details/12345',
    reply: async () => {
      await wait()
      return [status.ok, equalityDevicesInfo]
    }
  },
  {
    method: 'GET',
    path: '/models/nuovo/24075RP89G',
    reply: async () => {
      await wait()
      return [status.ok, modelsNuovo]
    }
  },
  {
    method: 'GET',
    path: '/credits/reset-password/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/penalty_quote_reset',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/penalty_quote_reset',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/warranty-requests/12345/complete',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/credits/replace',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/remove-nuovo/12345',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/warranty-requests/12345/delete',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/clients/2/check-assignment-availability',
    reply: async () => {
      await wait()
      return [status.ok, { data: { recentlyCreated: true } }]
    }
  },
  {
    method: 'GET',
    path: '/suppliers/by-brand/1?clientId=2',
    reply: async () => {
      await wait()
      return [status.ok, supplier]
    }
  },
  {
    method: 'GET',
    path: '/suppliers/by-brand/7?clientId=2',
    reply: async () => {
      await wait()
      return [status.ok, supplierApple]
    }
  },
  {
    method: 'GET',
    path: '/suppliers/by-brand/60?clientId=2',
    reply: async () => {
      await wait()
      return [status.ok, supplierNuovoLaptop]
    }
  },
  {
    method: 'GET',
    path: '/credits/by-register-number/LAPTOP01/2?supplierId=1&productTypeId=2',
    reply: async () => {
      await wait()
      return [status.ok, creditLaptopWithPromotionByRegisterNumber]
    }
  },
  {
    method: 'GET',
    path: '/suppliers/by-brand/50?clientId=2',
    reply: async () => {
      await wait()
      return [status.ok, supplierAutomotive]
    }
  },
  {
    method: 'GET',
    path: '/suppliers/by-brand/99?clientId=2',
    reply: async () => {
      await wait()
      return [status.ok, supplierMundo]
    }
  },
  {
    method: 'POST',
    path: '/credits/send-code',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/devices/enrollment_details/12345',
    reply: async () => {
      await wait()
      return [status.ok, QRImageData]
    }
  },
  {
    method: 'GET',
    path: '/clients/2/otp_verify',
    reply: async () => {
      await wait()
      return [status.ok, otpVerify]
    }
  },
  {
    method: 'POST',
    path: '/credits/exchange/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/credits/1/temporary-unlock',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/credit_unpay/3',
    reply: async () => {
      await wait()
      return [status.ok, creditUnpay]
    }
  },
  {
    method: 'POST',
    path: '/ocr/origin-certificate',
    reply: async () => {
      await wait()
      return [status.ok, readOriginCertificate]
    }
  }
]
